
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claim-kep",
      function () {
        return require("private-next-pages/claim-kep.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claim-kep"])
      });
    }
  